import React from 'react';
import PropTypes from 'prop-types';
import s from './index.module.scss';

function Option({ isSelected, className, onSelect, children }) {
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect?.();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={isSelected}
      className={`${className} ${isSelected ? s.optionSelected : ''}`}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
    >
      {children}
    </div>
  );
}

export default Option;

Option.propTypes = {
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  onSelect: PropTypes.func,
  children: PropTypes.node,
};

Option.defaultProps = {
  isSelected: false,
  className: '',
  onSelect: undefined,
  children: null,
};
